import { render, staticRenderFns } from "./AppAnomaliasServiceOrdersDashboard.vue?vue&type=template&id=4e54ce24&scoped=true&"
import script from "./AppAnomaliasServiceOrdersDashboard.vue?vue&type=script&lang=js&"
export * from "./AppAnomaliasServiceOrdersDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AppAnomaliasServiceOrdersDashboard.vue?vue&type=style&index=0&id=4e54ce24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e54ce24",
  null
  
)

export default component.exports